export default {
  columns: {
    consignmentNo: 'Consignment No.',
    relateFhNo: 'Related Shipping Request No.',
    consignmentStatus: 'Consignment Status',
    feeConfirmStatus: 'Fee Confirmation Status',
    writeOffStatus: 'Write-off Status',
    transportSegment: 'Transport Segment',
    direction: 'Direction',
    originCountry: 'Origin Country',
    originPort: 'Port of Loading',
    originWarehouse: 'Origin Warehouse',
    destinationCountry: 'Destination Country',
    destinationPort: 'Port of Discharge',
    destinationWarehouse: 'Destination Warehouse',
    businessDepartmentCode: 'Business Department Code',
    businessDepartmentName: 'Business Department',
    customerCode: 'Customer Code',
    customerName: 'Customer Name',
    skuProductName: 'SKU / Product Name',
    totalCargoValue: 'Total Cargo Value',
    chargeableWeight: '[Cargo Metrics] Chargeable Weight (kg)',
    totalVolume: '[Cargo Metrics] Total Volume (m³)',
    totalWeight: '[Cargo Metrics] Total Weight (kg)',
    segmentTransportMode: 'Segment Transport Mode',
    containerTypes: 'Container Types',
    supplierShortName: 'Supplier Short Name',
    supplierName: 'Supplier Name',
    carrierNames: 'Airline / Shipping Line',
    estimatedPayableOriginal: 'Estimated Amount (Tax-inclusive, Original Currency)',
    totalFreightUsd: 'Total Freight (USD)',
    exceptionStatus: 'Exception Status',
    exceptionSituation: 'Exception Details',
    sourceCreator: 'Source System Created By',
    businessCreatedAt: 'Business Created At',
    consignmentCreator: 'Consignment Created By',
    consignmentCreatedAt: 'Consignment Created At',
    waybillNos: 'Related Waybill No.',
    tradeTerms: 'Trade Terms (Import Clearance)',
    expectedArrivalAt: 'Expected Arrival At',
    orderReferenceRemark: 'Order Reference (PO/FBA/SW)',
    settlementTotalOriginal: 'Settlement Fees (Original Currency)'
  },
  feeDimensions: {
    duty: 'Duty',
    vat: 'VAT',
    freight: 'Freight',
    compensation: 'Compensation',
    preCarriageFreight: 'Pre-carriage Freight',
    originCustomsClearance: 'Origin Customs Clearance',
    mainCarriageFreight: 'Main Carriage Freight',
    destinationCustomsClearance: 'Destination Customs Clearance',
    onCarriageFreight: 'On-carriage Freight',
    other: 'Other'
  },
  feeColumns: {
    original: '{name} (Original Currency)',
    usd: '{name} (USD)'
  },
  title: 'Report Center',
  configModules: {
    filter: 'Report Center - Transport Consignment Shared Filters',
    managementTable: 'Report Center - Transport Consignment Management View Columns',
    followUpTable: 'Report Center - Transport Consignment Follow-up View Columns'
  },
  transportConsignment: {
    title: 'Transport Consignment Report',
    selectedCount: '{count} selected'
  },
  views: {
    MANAGEMENT: 'Management View',
    FOLLOW_UP: 'Follow-up View'
  },
  actions: {
    refresh: 'Refresh',
    export: 'Export',
    cancel: 'Cancel'
  },
  filters: {
    title: 'Report Center Filters',
    placeholders: {
      input: 'Enter a value',
      select: 'Select',
      dateRange: 'Select a date range'
    },
    fields: {
      consignmentNo: 'Consignment No.',
      relateFhNo: 'Related Shipping Request No.',
      consignmentStatus: 'Consignment Status',
      feeConfirmStatus: 'Fee Confirmation Status',
      transportSegment: 'Transport Segment',
      direction: 'Direction',
      originWarehouse: 'Origin Warehouse',
      originCountry: 'Origin Country',
      destinationWarehouse: 'Destination Warehouse',
      destinationCountry: 'Destination Country',
      businessDepartmentName: 'Business Department Name',
      customerCode: 'Customer Code',
      skuProductName: 'SKU / Product Name',
      segmentTransportMode: 'Segment Transport Mode',
      supplierName: 'Supplier Name',
      exceptionStatus: 'Exception Status',
      exceptionSituation: 'Exception Details',
      consignmentCreator: 'Consignment Created By',
      consignmentCreatedAt: 'Consignment Created At',
      sourceCreator: 'Source System Created By',
      businessCreatedAt: 'Business Created At'
    },
    options: {
      consignmentStatus: {
        0: 'Not Consigned',
        1: 'Consigned',
        2: 'Cancelled'
      },
      feeConfirmStatus: {
        0: 'Unconfirmed',
        1: 'Confirmed',
        2: 'Irrelevant'
      },
      writeOffStatus: {
        0: 'Not Written Off',
        1: 'Written Off',
        2: 'Partially Written Off'
      },
      transportSegment: {
        1: 'Pre-carriage',
        2: 'Mainline',
        3: 'On-carriage',
        4: 'End-to-end',
        5: 'Pre-carriage and Mainline',
        6: 'Mainline and On-carriage'
      },
      direction: {
        1: 'Forward',
        2: 'Reverse'
      },
      segmentTransportMode: {
        1: 'Ocean FCL',
        2: 'Ocean LCL',
        3: 'Air',
        4: 'Road',
        5: 'Rail',
        6: 'Express',
        7: 'Ro-Ro',
        8: 'Breakbulk',
        9: 'Other'
      },
      exceptionStatus: {
        0: 'No Exception',
        1: 'Has Exception'
      }
    }
  },
  export: {
    title: 'Export Data',
    description: 'The export uses the current view, filters, visible columns, and column order.',
    allRows: 'Export all matching records',
    selectedRows: 'Export selected records ({count})',
    selectedRowsDisabled: 'Export selected records (select records first)',
    confirm: 'Confirm Export',
    noSelectedRows: 'Select at least one record to export',
    noVisibleColumns: 'There are no visible columns available for export',
    filename: '菜单字段看板_{timestamp}'
  },
  values: {
    view: 'Report View',
    waybill: 'Waybill',
    metricSources: {
      FORWARDER: 'Forwarder',
      WAREHOUSE: 'Warehouse',
      THEORETICAL: 'Theoretical',
      MIXED: 'Mixed'
    },
    missingUsdRate: 'Missing USD exchange rate: {currencies}',
    actual: 'Actual',
    notApplicable: 'Not Applicable'
  },
  messages: {
    permissionDenied: 'You do not have permission to access this report view.',
    loadListFailed: 'Failed to load the report list',
    exportSuccess: 'The export has completed',
    exportFailed: 'Export failed. Please try again later.'
  }
}
